import { Navigate, Outlet, Link, useLocation } from "react-router-dom";
import { LogOut, LayoutGrid, Settings, Truck, ArrowUpDown, FileText, BarChart3, Image as ImageIcon, Hammer } from "lucide-react";
import { useAdminAuth } from "@/admin/AdminAuthContext";

const FEATURE_NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutGrid, testId: "admin-nav-dashboard", exact: true },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3, testId: "admin-analytics-link" },
  { to: "/admin/bushcabin-builds", label: "Bush Cabin Builds", icon: Hammer, testId: "admin-bushcabin-builds-link" },
  { to: "/admin/posters", label: "Posters", icon: ImageIcon, testId: "admin-posters-link" },
  { to: "/admin/shipping-rates", label: "Shipping Rates", icon: Truck, testId: "admin-shipping-rates-link" },
  { to: "/admin/category-order", label: "Category Order", icon: ArrowUpDown, testId: "admin-category-order-link" },
  { to: "/admin/legal-pages", label: "Policy Pages", icon: FileText, testId: "admin-legal-pages-link" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testId: "admin-settings-link" },
];

export default function AdminLayout() {
  const { admin, logout } = useAdminAuth();
  const location = useLocation();

  if (admin === null) {
    return <div className="min-h-screen flex items-center justify-center text-white/60 font-mono text-sm">Checking session…</div>;
  }
  if (admin === false) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return (
    <div className="min-h-screen bg-[var(--bg-main)] text-white">
      <header className="border-b border-[var(--border-default)] bg-[var(--bg-secondary)]">
        <div className="container-x py-4 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-2 font-display text-lg">
            <LayoutGrid size={18} className="text-[var(--brand-primary)]" />
            Admin Panel
          </Link>
          <div className="flex items-center gap-4">
            <span className="text-xs font-mono text-white/50">{admin.email}</span>
            <button
              data-testid="logout-button"
              onClick={logout}
              className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-white/70 hover:text-[var(--brand-primary)]"
            >
              <LogOut size={14} /> Logout
            </button>
          </div>
        </div>
        <nav className="container-x flex items-center gap-1 overflow-x-auto pb-3">
          {FEATURE_NAV.map((item) => {
            const isActive = item.exact ? (location.pathname === "/admin" || location.pathname === "/admin/") : location.pathname.startsWith(item.to);
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={item.testId}
                className={`shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-mono uppercase tracking-widest border transition-colors ${
                  isActive
                    ? "border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "border-transparent text-white/50 hover:text-white"
                }`}
              >
                <Icon size={14} /> {item.label}
              </Link>
            );
          })}
        </nav>
      </header>
      <main className="container-x py-8">
        <Outlet />
      </main>
    </div>
  );
}
